function isValidFloat(value: string): boolean {
    const parsedValue = Number.parseFloat(value);
    return !isNaN(parsedValue);
}

export default isValidFloat
